// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__G-MDH","header":"ReportDetails_header__2AVyJ","title":"ReportDetails_title__572lu","left":"ReportDetails_left__1hSc8"};